import { Injectable } from '@angular/core'
import { MatDialog } from '@angular/material/dialog'
import { firstValueFrom } from 'rxjs'
import { NotificationsDialogComponent } from '../notifications-dialog/notifications-dialog.component'
import { VideoDialogComponent } from '../video-dialog/video-dialog.component'

@Injectable({
  providedIn: 'platform',
})
export class ToolbarService {
  public constructor(private readonly matDialog: MatDialog) { }

  public async openVideoDialog(videoUrl: string): Promise<void> {
    const dialogRef = this.matDialog.open(VideoDialogComponent, {
      data: videoUrl,
    })

    return firstValueFrom(dialogRef.afterClosed())
  }

  public async openNotificationsDialog(environment: any): Promise<void> {
    const dialogRef = this.matDialog.open(NotificationsDialogComponent, {
      panelClass: ['notifications-dialog'],
      width: '500px',
      height: '100%',
      autoFocus: false,
      position: {
        right: '0',
        top: '0',
      },
      data: {
        environment
      }
    })

    await firstValueFrom(dialogRef.afterClosed())
  }
}
